import { SideSheetGroupedSelectOptionGroup } from "../../components/side-sheet/side-sheet-grouped-select/SideSheetGroupedSelect";


export type ConfigurationsStateType = {
    configurations: SideSheetGroupedSelectOptionGroup<number>[] | undefined;
    configurationID: number | undefined;
}

export type ConfigurationsContextType = {
    //optionGroups: SideSheetGroupedSelectOptionGroup<number>[];
    //configurationID: number;
    configurationsContextState: ConfigurationsStateType;
    setContextConfigurations: (value: SideSheetGroupedSelectOptionGroup<number>[]) => void;
    setContextConfigurationID: (value: number) => void;

};

export enum ConfigurationsContextActionType {
    ConfigurationsChanged = 'CONFIGURATIONS_CONTEXT_CONFIGURATIONS_CHANGED',
    ConfigurationChanged = 'CONFIGURATIONS_CONTEXT_CONFIGURATION_CHANGED',
    ResetChanged = 'CONFIGURATIONS_CONTEXT_RESET'

}

export type ConfigurationsContextAction = {
    type: ConfigurationsContextActionType.ConfigurationsChanged;
    payload: SideSheetGroupedSelectOptionGroup<number>[];
} | {
    type: ConfigurationsContextActionType.ConfigurationChanged;
    payload: number;
} | {
    type: ConfigurationsContextActionType.ResetChanged;
    payload: void;
};
